import { RootState } from './index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalSliceInitiator, modalStatusEnum } from '../types/modal';

const MODAL_KEY = 'modal';

const initialState: ModalSliceInitiator = {
    modalStatus : 0,
    modalMessage: '',
    modalReset: false
}

const ModalSlice = createSlice({
    name: MODAL_KEY,
    initialState,
    reducers: {
        setModalStatus: (state, action: PayloadAction<modalStatusEnum>) => {
            state.modalStatus = action.payload
        },
        setModalMessage: (state, action: PayloadAction<string>) => {
            state.modalMessage = action.payload
        },
        setModalReset: (state, action: PayloadAction<boolean>) => {
            state.modalReset = action.payload
        },
    }
});

export const { setModalStatus, setModalMessage, setModalReset } = ModalSlice.actions
export default ModalSlice.reducer;

export const getModalStatus = (state: RootState) => state.modal.modalStatus
export const getModalMessage = (state: RootState) => state.modal.modalMessage
export const getModalReset = (state: RootState) => state.modal.modalReset